import { ANALYTICS_ACTIVE_VALUE } from '@/constants/analytics';

export function isAnalyticsActive(): boolean {
  // Must be a static `process.env.NEXT_PUBLIC_*` access so Next inlines it
  // into the client bundle at build time (dynamic keys are not replaced).
  return process.env.NEXT_PUBLIC_ANALYTICS_ACTIVE === ANALYTICS_ACTIVE_VALUE;
}

/** Trimmed GA4 measurement ID, or `null` when unset / blank. */
export function getGaMeasurementId(): string | null {
  const value = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID?.trim();
  return value ? value : null;
}
